import "./neoAvatar.css";

export default function NeoAvatar({ size = 48, state = "idle" }) {
  return <span className="neo-avatar" data-state={state} aria-hidden="true" style={{ width: size, height: size }}>
    <span className="neo-body"><span className="neo-antenna" /><span className="neo-head">
      <span className="neo-face"><span className="neo-eyes"><i /><i /></span><span className="neo-mouth" />
      <span className="neo-dots"><i /><i /><i /></span></span>
    </span><span className="neo-chest">N</span><span className="neo-hand neo-hand-left" /><span className="neo-hand neo-hand-right" /></span>
  </span>;
}
